import datapoints from '../datapoints';
import storeTranslationStatus from '../services/storeTranslationStatus';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { ClientItem, mailStore } from 'owa-mail-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export default createLegacyActionWithDatapoint(
    'untranslateItem',
    datapoints.InlineTranslationMessageUntranslated
)(async function untranslateItem(itemId: string, isConversationItemPart: boolean = false) {
    const item: ClientItem = mailStore.items.get(itemId);
    if (isConversationItemPart) {
        const conversationId = item.ConversationId.Id;
        const conversationItemParts = mailStore.conversations.get(conversationId);
        conversationItemParts.subjectTranslationData.isShowingTranslation = false;
    } else {
        item.TranslationData.isShowingSubjectTranslation = false;
    }

    item.TranslationData.isShowingTranslation = false;
    item.TranslationData.isShowingForwardContentTranslation = false;
    if (isFeatureEnabled('tra-cacheTranslation')) {
        await storeTranslationStatus(item.ItemId.Id, false);
    }
});
